export const FEATURE_FLAG_COOKIE_NAME = 'x-flag'
export const FEATURE_FLAG_HEADER_NAME = 'X-Flag'

export const flags = {
  FLAG_FOR_TESTING: 'pga-com-flag-for-testing',
  FLAG_COACH_SEARCH_INFO_VISUALIZATION: 'pga-com-coach-search-info-visualization',
  FLAG_CUSTOM_PAGE: 'pga-com-custom-page',
  FLAG_MEMBERSHIP_HOLE_IN_ONE: 'pga-com-hole-in-one-registry',
  FLAG_CONTACT_BUTTON_LABEL: 'pga-com-contact-button-label',
}
